export var MARKDOWN_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg"];
export var MARKDOWN_IMAGE_MIME_TYPES = ["image/png", "image/jpeg", "image/jpg"];
var URL_CANDIDATE_PATTERN = /https?:\/\/[^\s"'<>`]+/gi;
var decodeCommonHtmlEntities = function (value) {
    return value
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, "\"")
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">");
};
var cleanUrlCandidate = function (value) {
    var candidate = decodeCommonHtmlEntities(value).trim();
    while (candidate && /[\]),.;:!?]$/.test(candidate)) {
        candidate = candidate.slice(0, -1);
    }
    return candidate;
};
export var isSupportedMarkdownImageUrl = function (value) {
    try {
        var url = new URL(cleanUrlCandidate(value));
        if (url.protocol !== "http:" && url.protocol !== "https:")
            return false;
        var pathname_1 = url.pathname.toLowerCase();
        return MARKDOWN_IMAGE_EXTENSIONS.some(function (extension) { return pathname_1.endsWith(".".concat(extension)); });
    }
    catch (_a) {
        return false;
    }
};
export var findSupportedMarkdownImageUrl = function (value) {
    if (!value)
        return undefined;
    var decoded = decodeCommonHtmlEntities(value);
    var urls = decoded.match(URL_CANDIDATE_PATTERN) || [];
    return urls
        .map(cleanUrlCandidate)
        .find(isSupportedMarkdownImageUrl);
};
export var getSupportedMarkdownImageUrlFromTransfer = function (transfer) {
    var uriListUrl = transfer
        .getData("text/uri-list")
        .split(/\r?\n/)
        .map(function (line) { return cleanUrlCandidate(line); })
        .find(function (line) { return line && !line.startsWith("#") && isSupportedMarkdownImageUrl(line); });
    if (uriListUrl)
        return uriListUrl;
    var plainTextUrl = findSupportedMarkdownImageUrl(transfer.getData("text/plain"));
    if (plainTextUrl)
        return plainTextUrl;
    return findSupportedMarkdownImageUrl(transfer.getData("text/html"));
};
export var filesFromTransfer = function (transfer) {
    var _a;
    if ((_a = transfer.files) === null || _a === void 0 ? void 0 : _a.length)
        return Array.from(transfer.files);
    return Array.from(transfer.items || [])
        .filter(function (item) { return item.kind === "file"; })
        .map(function (item) { return item.getAsFile(); })
        .filter(function (file) { return !!file; });
};
export var transferHasFiles = function (transfer) {
    var _a;
    return !!transfer && (Array.from(transfer.types || []).includes("Files")
        || !!((_a = transfer.files) === null || _a === void 0 ? void 0 : _a.length)
        || Array.from(transfer.items || []).some(function (item) { return item.kind === "file"; }));
};
export var isSupportedMarkdownImageMimeType = function (mimeType) {
    return !!mimeType && MARKDOWN_IMAGE_MIME_TYPES.includes(mimeType.toLowerCase());
};
export var isSupportedMarkdownImageFile = function (file) {
    return isSupportedMarkdownImageMimeType(file.type);
};
export var getImageFileFromTransfer = function (transfer) {
    return filesFromTransfer(transfer).find(function (file) { return file.type.startsWith("image/"); });
};
export var getSupportedMarkdownImageFileFromTransfer = function (transfer) {
    return filesFromTransfer(transfer).find(isSupportedMarkdownImageFile);
};
export var getSupportedMarkdownImagePaste = function (transfer) {
    var imageUrl = getSupportedMarkdownImageUrlFromTransfer(transfer);
    if (imageUrl)
        return { type: "url", url: imageUrl };
    var imageFile = getSupportedMarkdownImageFileFromTransfer(transfer);
    if (imageFile)
        return { type: "file", file: imageFile };
    return null;
};
export var fileNameFromMarkdownImageUrl = function (url) {
    try {
        var pathname = new URL(cleanUrlCandidate(url)).pathname;
        var lastSegment = pathname.substring(pathname.lastIndexOf("/") + 1);
        return decodeURIComponent(lastSegment) || "image";
    }
    catch (_a) {
        return "image";
    }
};
